import React from "react";
import { inject, observer } from "mobx-react";
import { Link } from "react-router-dom";
import { Glyphicon, Modal, Button } from "react-bootstrap";
import { CustomTooltip } from "../../tooltip/CustomTooltip";
import CellContent from "../../vis/template/CellContent";
import MaintenanceAgencyLabel from "../../detail/MaintenanceAgencyLabel";

@inject("http", "searchStore")
@observer
class MemberHierarchyModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tid: "",
      data: "",
      tree: [],
      showModal: false,
      cubeTypePanelStates: {},
    };
  }

  componentDidMount() {
    const { tid } = this.props;
    this.renderModalData(tid);
  }

  renderModalData = (tid) => {
    const fetchProps = {
      type: "MemberHierarchy",
      tid: tid,
      queryParamsForBuckets: {
        "Member Hierarchies": {
          filter: {
            type: "MemberHierarchy",
            universalFilter: null,
          },
          limit: {
            offset: 0,
            limit: 100,
          },
        },
        "Member Hierarchy Nodes": {
          filter: {
            type: "MemberHierarchyNode",
            universalFilter: null,
          },
          limit: {
            offset: 0,
            limit: 100,
          },
        },
      },
      resultsInTree: true,
      resultsInBuckets: true,
    };

    this.props.http.fetchEntityDetails(fetchProps, true).then((response) => {
      const data = JSON.parse(JSON.stringify(response));
      const tree = this.initTree(data);
      this.setState({
        tid,
        data,
        tree,
      });
    });
  };

  checkIfOpen = (id) => {
    const { modalOpenItems } = this.props;
    return modalOpenItems.includes(id);
  };

  toggleOpen = (id) => {
    const { onOpenChange } = this.props;
    const { tree } = this.state;
    const newTree = [...tree];
    const target = newTree.find((item) => item.id === id);
    if (!target || !target.hasChildren) return;
    target.isOpen = !target.isOpen;
    onOpenChange(
      newTree.filter((item) => item.isOpen === true).map((item) => item.id)
    );
  };

  initTree = (model) => {
    let memberHierarchyTrees = "";
    if (
      model &&
      model.item &&
      model.item.otherInformation &&
      model.item.otherInformation.memberHierarchyTree
    ) {
      memberHierarchyTrees = this.props.processMemberHierarchyTrees(
        model.item.otherInformation.memberHierarchyTree
      );
    }
    const arr = [];
    const processItem = (item, parentId = null) => {
      arr.push({
        id: item.id,
        isOpen: this.props.modalOpenItems.includes(item.id),
        hasChildren: !!item.children,
        parentId,
      });
      if (item.children) {
        item.children.forEach((child) => {
          processItem(child, item.id);
        });
      }
    };
    if (memberHierarchyTrees.children && memberHierarchyTrees.children.length) {
      memberHierarchyTrees.children.forEach((child) => {
        processItem(child);
      });
    }
    return arr;
  };

  handleCubeTypePanelCollapse = (tid, limit, isOpen) => {
    this.setState((prevState) => ({
      ...prevState,
      cubeTypePanelStates: {
        ...prevState.cubeTypePanelStates,
        [tid]: { limit, isOpen },
      },
    }));
  };

  handleLimitVizualisation = (child) => {
    const { tid } = child;
    const isOpened =
      this.state.cubeTypePanelStates[tid] === undefined
        ? true
        : !this.state.cubeTypePanelStates[tid].isOpen;
    const length =
      this.state.cubeTypePanelStates[tid] === undefined
        ? child.sddMemberHierarchy.length
        : isOpened
        ? child.sddMemberHierarchy.length
        : 2;
    this.handleCubeTypePanelCollapse(tid, length, isOpened);
  };

  renderGroup = (children) => {
    if (!children) return null;
    return (
      <ul>
        {children.map((child) => (
          <li key={child.id}>
            <div className="sdd-tree-item-label">
              {child.children && child.children.length > 0 ? (
                <Glyphicon
                  glyph={
                    this.checkIfOpen(child.id) === true
                      ? "chevron-down"
                      : "chevron-right"
                  }
                  onClick={() => this.toggleOpen(child.id)}
                />
              ) : null}
              <span
                onClick={() => this.toggleOpen(child.id)}
                className="sdd-tree-item-name"
              >
                <Link to={`/view/${child.type}/${child.tid}`} target="_blank">
                  <span>{child.name}</span>
                </Link>
                {` (${child.code}) `}
              </span>
              <div className="member-hierarchy-tooltip-group">
                <div>
                  {child.sddMemberHierarchy &&
                    child.sddMemberHierarchy
                      .filter((memberHierarchy) => {
                        return memberHierarchy.tid !== this.state.tid;
                      })
                      .map((hierarchyChild) => {
                        return (
                          <span
                            className="member-hierarchy-button"
                            key={hierarchyChild.tid}
                          >
                            <button
                              type="button"
                              className="btn btn-sm btn-default"
                              onClick={() =>
                                this.renderModalData(hierarchyChild.tid)
                              }
                            >
                              <CellContent
                                maxLength={40}
                                content={hierarchyChild.name}
                                id={0}
                              />
                            </button>
                          </span>
                        );
                      })}
                  {child.sddMemberHierarchy &&
                  child.sddMemberHierarchy.filter((memberHierarchy) => {
                    return memberHierarchy.tid !== this.state.tid;
                  }).length > 2 ? (
                    <Button
                      bsSize="xsmall"
                      onClick={() => this.handleLimitVizualisation(child)}
                      bsClass="btn btn-default btn-xs dropdown-toggle"
                      style={{ backgroundColor: "#003299", color: "white" }}
                    >
                      {`Read ${
                        this.state.cubeTypePanelStates[child.tid] === undefined
                          ? "more"
                          : this.state.cubeTypePanelStates[child.tid] &&
                            this.state.cubeTypePanelStates[child.tid].isOpen
                          ? "less"
                          : "more"
                      }`}
                    </Button>
                  ) : (
                    ""
                  )}
                </div>
                {child.sddMemberHierarchy &&
                child.sddMemberHierarchy.filter((memberHierarchy) => {
                  return memberHierarchy.tid !== this.state.tid;
                }).length > 0 ? (
                  <div className="member-hierarchy-tooltip">
                    {child.sddMemberHierarchy && (
                      <CustomTooltip type="Cube Link Variable" />
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
            {child.children && this.checkIfOpen(child.id) === true
              ? this.renderGroup(child.children)
              : null}
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const {
      title,
      isOpened,
      closeModalTree,
      searchStore: { getMetadata },
      processMemberHierarchyTrees,
    } = this.props;

    const metadata = getMetadata["MemberHierarchy"];

    let dataObject = "";
    if (
      this.state.data &&
      this.state.data.item &&
      this.state.data.item.object
    ) {
      dataObject = this.state.data.item.object;
    }
    let definedOn = "";
    if (
      this.state.data &&
      this.state.data.item &&
      this.state.data.item.definedOn
    ) {
      definedOn = this.state.data.item.definedOn;
    }

    let memberHierarchyTrees = "";
    if (
      this.state.data &&
      this.state.data.item &&
      this.state.data.item.otherInformation &&
      this.state.data.item.otherInformation.memberHierarchyTree
    ) {
      memberHierarchyTrees = processMemberHierarchyTrees(
        this.state.data.item.otherInformation.memberHierarchyTree
      );
    }

    return (
      <div>
        <Modal
          show={isOpened}
          onHide={() => closeModalTree()}
          dialogClassName="member-hierarchy-modal-window"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <strong>{title}</strong>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
              <div className="descriptive-metadata custom-panel">
                <div
                  className={`custom-panel-heading ${
                    dataObject.omaintenanceAgencyId &&
                    dataObject.maintenanceAgencyId === "ECB"
                      ? "reference"
                      : "non-reference"
                  }`}
                >
                  <h4>{"Member Hierarchy"}</h4>
                  <CustomTooltip type={"MemberHierarchy"} />
                </div>
                <div className="custom-panel-body">
                  {metadata.fieldsForDescriptiveMetadataSection.map(
                    (field, index) => {
                      return (
                        <p key={index}>
                          <b>{metadata.labelsForFields[field]}:</b>{" "}
                          {dataObject[field] || "-"}
                        </p>
                      );
                    }
                  )}
                  {dataObject.maintenanceAgencyId ? (
                    <p>
                      <b>Maintenance agency:</b>{" "}
                      {dataObject.maintenanceAgencyId}
                    </p>
                  ) : (
                    ""
                  )}
                  {definedOn && definedOn.length
                    ? definedOn.map((item, index) => {
                        const itemObj = item.object;
                        const itemUrl = `/view/${itemObj.type}/${itemObj.tid}`;
                        const itemFields =
                          getMetadata[itemObj.type].fieldsForSearchResultView;
                        const titleItems = [];
                        const nameField = itemFields.find((x) =>
                          x.toLowerCase().includes("name")
                        );
                        if (nameField) {
                          titleItems.push(
                            <Link
                              key="title-name"
                              className="object-name"
                              to={itemUrl}
                            >
                              {itemObj[nameField]}
                            </Link>
                          );
                        }
                        const legalCodeField = itemFields.find((x) =>
                          x.includes("legalCode")
                        );
                        if (legalCodeField) {
                          titleItems.push(
                            <Link
                              key="title-legalCode"
                              className="object-name"
                              to={itemUrl}
                            >
                              {itemObj[legalCodeField]}
                            </Link>
                          );
                        }
                        const codeField = itemFields.find((x) =>
                          x.includes("code")
                        );
                        if (codeField) {
                          titleItems.push(`(${itemObj[codeField]})`);
                        }
                        if (itemObj.maintenanceAgencyId) {
                          titleItems.push(
                            <MaintenanceAgencyLabel
                              maintenanceAgencyId={itemObj.maintenanceAgencyId}
                            ></MaintenanceAgencyLabel>
                          );
                        }
                        return (
                          <p key={index}>
                            <b>Is defined on {itemObj.type}: </b>
                            {titleItems}
                          </p>
                        );
                      })
                    : ""}
                </div>
              </div>
              <div className="mapping custom-panel">
                <div className="custom-panel-heading">
                  <h4>Hierarchy Representation</h4>
                </div>
                <div className="custom-panel-body">
                  <div className="sdd-vis-container" style={{ height: "auto" }}>
                    <div
                      className="sdd-tree-container tree-only"
                      style={{ paddingTop: "0px" }}
                    >
                      <div className="sdd-tree">
                        {this.renderGroup(memberHierarchyTrees.children)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default MemberHierarchyModal;
